import { render, staticRenderFns } from "./ClientForm3.vue?vue&type=template&id=0f6ed5b2&scoped=true"
import script from "./ClientForm3.ts?vue&type=script&lang=ts&external"
export * from "./ClientForm3.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6ed5b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6ed5b2')) {
      api.createRecord('0f6ed5b2', component.options)
    } else {
      api.reload('0f6ed5b2', component.options)
    }
    module.hot.accept("./ClientForm3.vue?vue&type=template&id=0f6ed5b2&scoped=true", function () {
      api.rerender('0f6ed5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/ClientForm3/ClientForm3.vue"
export default component.exports